function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10.705626mm",
    height: "10.76755mm",
    viewBox: "0 0 10.705626 10.76755",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18.398424,-2.4861977)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.664054,-2.0579751)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.31907,
      strokeLinecap: "round"
    },
    d: "M 10.196332,32.834061 C 10.44491,33.124851 9.9269923,33.312605 9.7130193,33.247214 9.1331658,33.07001 9.0974566,32.306731 9.3700244,31.867435 9.8575841,31.081638 10.964748,31.07176 11.64627,31.594599 c 1.000161,0.767288 0.981926,2.258129 0.202677,3.172712 -1.038617,1.218996 -2.9248247,1.170842 -4.0691785,0.132519 -1.4400524,-1.306624 -1.3611437,-3.593099 -0.062359,-4.965645 1.5730019,-1.662338 4.2622639,-1.552252 5.8621119,0.0078 1.885365,1.838466 1.743865,4.931984 -0.07796,6.758578 -2.103367,2.108876 -5.6020742,1.935816 -7.6550442,-0.148117 -2.3327151,-2.367897 -2.1280029,-6.272426 0.2182761,-8.551511 2.6321705,-2.55679 6.9429671,-2.320361 9.4479781,0.288435 2.781036,2.896258 2.512847,7.613651 -0.358594,10.344444",
    transform: "matrix(0.73401613,0,0,0.78299898,26.46697,-15.454928)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.5be1473debf008df3ce26596853b2f1f.svg";
export { ForwardRef as ReactComponent };